package app.smartcoding.realrate.domain.model

import androidx.compose.runtime.Stable
import androidx.compose.ui.text.input.TextFieldValue
import kotlinx.datetime.*
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

@OptIn(ExperimentalTime::class)
@Stable
data class CreditInputs(
    val loanReceivedAmount: TextFieldValue = TextFieldValue("20000"),
    val loanRequestedAmount: TextFieldValue = TextFieldValue("20000"),
    val loanTaxFee: TextFieldValue = TextFieldValue("0"),
    val loanTaxRate: TextFieldValue = TextFieldValue("0"),

    val termsMonthsTotal: TextFieldValue = TextFieldValue("120"),
    val termsYears: TextFieldValue = TextFieldValue("10"),
    val termsMonths: TextFieldValue = TextFieldValue("0"),

    val paymentTotal: TextFieldValue = TextFieldValue("200"),
    val paymentMain: TextFieldValue = TextFieldValue("200"),
    val paymentInsurance: TextFieldValue = TextFieldValue("0"),
    val paymentFees: TextFieldValue = TextFieldValue("0"),

    val showDetailedLoanAmountInput: Boolean = false,
    val showDetailedMountsInput: Boolean = false,
    val showDetailedPaymentInput: Boolean = false,
    val isLockedTaxRate: Boolean = false,

    @Stable
    val startDate: LocalDate = run {
        val today = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault()).date
        val nextMonth = today.plus(1, DateTimeUnit.MONTH)
        LocalDate(nextMonth.year, nextMonth.month, 1)
    },
)

data class CreditInputsText(
    val loanReceivedAmount: String,
    val loanRequestedAmount: String,
    val loanTaxFee: String,
    val loanTaxRate: String,

    val termsMonthsTotal: String,
    val termsYears: String,
    val termsMonths: String,

    val paymentTotal: String,
    val paymentMain: String,
    val paymentInsurance: String,
    val paymentFees: String,

    val showDetailedLoanAmountInput: Boolean,
    val showDetailedMountsInput: Boolean,
    val showDetailedPaymentInput: Boolean,
    val isLockedTaxRate: Boolean,

    val startDate: LocalDate
) {
    companion object {
        fun fromCreditInput(creditInputs: CreditInputs): CreditInputsText {
            return CreditInputsText(
                loanReceivedAmount = creditInputs.loanReceivedAmount.text,
                loanRequestedAmount = creditInputs.loanRequestedAmount.text,
                loanTaxFee = creditInputs.loanTaxFee.text,
                loanTaxRate = creditInputs.loanTaxRate.text,
                termsMonthsTotal = creditInputs.termsMonthsTotal.text,
                termsYears = creditInputs.termsYears.text,
                termsMonths = creditInputs.termsMonths.text,
                paymentTotal = creditInputs.paymentTotal.text,
                paymentMain = creditInputs.paymentMain.text,
                paymentInsurance = creditInputs.paymentInsurance.text,
                paymentFees = creditInputs.paymentFees.text,
                showDetailedLoanAmountInput = creditInputs.showDetailedLoanAmountInput,
                showDetailedMountsInput = creditInputs.showDetailedMountsInput,
                showDetailedPaymentInput = creditInputs.showDetailedPaymentInput,
                isLockedTaxRate = creditInputs.isLockedTaxRate,
                startDate = creditInputs.startDate
            )
        }
    }
}